export default "__VITE_ASSET__Bwh7oKvu__"